import { ITtsState } from 'store/types/tts'

export const getInitialState = (): ITtsState => ({
  ttsInitialItems: {
    data: [],
    isLoading: false
  },
  ttsMutableItems: {
    data: [],
    isLoading: false
  },
  ttsCredits: { data: 0, isLoading: false },
  ttsGenerationStatus: null,
  newGeneratedItemsInitialIdAndStatus: [],
  isTtsMismatchPopupVisible: false
})
